<template>
  <div>
    <md-card>
      <!-- 卡片-主体 -->
      <md-card-content>
        <!-- 卡片-主体-表单-表格数据筛选 -->
        <div class="md-layout card-form" style="max-width: 600px;">
          <!-- 表单-选择栏-参数类型 -->
          <div class="md-layout-item md-size-40 left-layout-item">
            <md-field>
              <md-select v-model="formData.state">
                <md-option :value="'__ALL__'">{{$I18n("all")}}</md-option>
                <md-option v-for="item in stateOption" :value="item.id" :key="item.id">{{$I18n(item.name)}}</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-size-20">
            <md-button class= "left-icon md-info" @click="form_search">
              <md-icon>search</md-icon>
              {{$I18n("search")}}
            </md-button>
          </div>
        </div>
      </md-card-content>
    </md-card>
    <md-card>
      <!-- 卡片-主体 -->
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item">
            <add-button @click="addModal">{{$I18n("add")}}</add-button>
          </div>
        </div>
        <md-table v-model="tableData">
          <md-table-row slot="md-table-row" slot-scope="{ item }" >
            <md-table-cell :md-label="'ID'">{{ item.id }}</md-table-cell>
            <md-table-cell :md-label="$I18n('comp_name')">{{ item.comp_name }}</md-table-cell>
            <md-table-cell :md-label="$I18n('back_acc')">{{ item.bank_no }}</md-table-cell>
            <md-table-cell :md-label="$I18n('bank_name')">{{ item.bank_name }}</md-table-cell>
            <md-table-cell :md-label="$I18n('withdrawal_amount')">{{ item.amount }}</md-table-cell>
            <md-table-cell :md-label="$I18n('bill')">
              <div @click="() => openPDF(item.invoice_url)" style="cursor: pointer; color: rgb(0, 188, 212);">
                {{$I18n("check_bill")}}
              </div>
            </md-table-cell>
            <md-table-cell :md-label="$I18n('tax_rate')">{{ item.tax_rate ?item.tax_rate :"0" }}</md-table-cell>
            <md-table-cell :md-label="$I18n('state')">{{ item.state_name }}</md-table-cell>
            <md-table-cell :md-label="$I18n('rev_rem')">{{ item.approval_desc }}</md-table-cell>
            <md-table-cell :md-label="$I18n('apply_time')">{{ item._created_time }}</md-table-cell>
            <md-table-cell :md-label="$I18n('operate')"  class="button-box" style="width: 100px;">
              <md-button @click="setModal(item)" class="md-simple md-info md-table-md-button">
                {{$I18n("edit")}}
              </md-button >
            </md-table-cell>
          </md-table-row>
          <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
        </md-table>
        <!-- 翻页 -->
        <table-page :total="total" :pageSize="pageSize" v-model="pageNo"/>
      </md-card-content>
    </md-card>
    <!-- 弹窗 -->
    <simple-modal 
      class="other-modal"
      ref        = "modal"
      :title     = "modalTitle"
      :right     = "openModalType!=='delete'"
      :large     = "openModalType==='import'"
      :submitBtn = "openModalType!=='import'"
      @submit    = "modal_submit"
      @close     = "can_change = false"
    >
      <template slot="body">
        <!-- 删除弹窗 -->
        <div v-if="openModalType==='delete'">{{$I18n("check_delete", modalData.Form.id)}}</div>
        <!-- 修改/添加弹窗 -->
        <div v-else-if="openModalType === 'edit'">
          <common-form-item 
            v-for="item in form_modalData_edit" 
            v-model="modalData_edit.Form[item.keys]" 
            :error="modalData_edit.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          />
        </div>
        <div v-else>
          <common-form-item 
            v-for="item in form_modalData" 
            v-model="modalData.Form[item.keys]" 
            :error="modalData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          >
            <div v-if="item.type == 'file'" style="position:relative;">
              <div style="position: absolute; top: -24px;">
                <span style="opacity:0;">{{$I18n("bill")}} *:</span>
                <el-tooltip class="item" effect="dark" placement="right">
                  <div slot="content">
                    <!-- {{$I18n("alias")}}: {{invo.name}}<br/> -->
                    {{$I18n("tax_no")}}: {{invo.tax_no}}<br/>
                    {{$I18n("comp_name")}}: {{invo.comp_name}}<br/>
                    {{$I18n("company_address")}}: {{invo.comp_addr}}<br/>
                    {{$I18n("bank_name_02")}}: {{invo.bank_name}}<br/>
                    {{$I18n("bank_no")}}: {{invo.bank_no}}<br/>
                  </div>
                  <span>{{$I18n("bill_title")}}</span>
                </el-tooltip>
              </div>
                <div>
                  <div v-if="modalData.Form.invoice_url" class="search-icon" @click="() => openPDF(modalData.Form.invoice_url)">
                    <p>{{$I18n("check_bill")}}</p>
                  </div>
                  <file-uploader
                    class="modal-loader"
                    @change="changeFile"
                    :typeFilter="['pdf']"
                    :sizeFilter_max="2"
                    :nameUseTime="true"
                  >
                    <div v-if="!modalData.Form.invoice_url" class="imagebox">
                      <img style="width:53px;" src="/img/upload.svg">
                      <div style="margin-top: 6px;">
                        <span style="text-transform: initial;">
                          {{$I18n("drag_file_01")}}
                          <i class="info-color" style="color: rgb(55, 199, 199); font-style: normal;">{{$I18n("drag_file_02")}}</i>
                        </span>
                      </div>
                    </div>
                    <div v-else class="imagebox">
                      <div class="click-upload">{{modalData.Form.invoice_url_name}}</div>
                    </div>
                  </file-uploader>
                </div>
            </div>
          </common-form-item>
        </div>
      </template>
    </simple-modal>
  </div>
</template>
<script>
import { FormClass, timestampToString } from "@/common/tools.js";
import FileUploader from "@/components/Common/FileUploader.vue";

const stateOption = [
  {
    id: 1,
    name: ("with_comp"),
  },{
    id: 2,
    name: ("no_audited"),
  },{
    id: 3,
    name: ("pend_pay"),
  },{
    id: 4,
    name: ("audit_fail"),
  },{
    id: 5,
    name: ("canceled"),
  },
]

export default {
  components: {
    FileUploader,
  },
  // props: ["userinfo_sys"],
  data() {
    return {
      stateOption,
      formData  : {
        state: "__ALL__",
      },
      searchData: {
        state:0,
      },
      banks: [], // 提现账号(只有开启状态)
      balance: {},
      invo: {},

      // Table 原始数据 (翻页)
      tableInitData: [],
      pageNo   : 1,
      total    : 0,
      pageSize: 10,

      openModalType : "",    // 弹窗类型
      modalTitle    : "",    // 弹窗标题

      // 弹窗表单相关
      modalData : new FormClass({
        license_url_name: "",
        comp_bank_id   :{
          init :"",
          check:"required",
        },
        amount   :{
          init :"",
          check:(val, form) => {
            return isNaN(val) || parseFloat(val) < 0 || parseFloat(val) > parseFloat(form.extra_curr)
          },
        },
        currency_code   :{
          init :"",
          check:"required",
        },
        invoice_url     :{
          init : "",
          check: "required",
        },
        tax_rate:{
          init : "",
          check: (value) =>{
            return isNaN(value) || parseFloat(value) < 0
          },
        },
      }),
      modalData_edit : new FormClass({
        state   :{
          init :1,
        },
        approval_desc   :{
          init :"",
        },
      })
    };
  },
  watch: {
    modalData:{
      handler(){ },
      immediate: true,
      deep: true,
    },
    // 'modalData.Form.currency_code':{
    //   handler(val){
    //     this.modalData.Form.extra_curr = this.balance[val]
    //   },
    //   immediate: true,
    //   deep: true,
    // },
    pageNo(){
      this.api_getPageData();
    },
  },
  computed:{
    // 表格数据处理
    tableData(){
      return [...this.tableInitData]
        .map(item => {
          const state = this.stateOption.filter(i => i.id == item.state)[0];
          let state_name = this.$I18n("unknow");
          if(state){
            state_name = this.$I18n(state.name);
          }
          return {
            ...item,
            state_name,
            _created_time : timestampToString(new Date(item.created_at).getTime()),
          }
        })
    },
    form_modalData_edit(){
      return [
        {
          label   : this.$I18n("state"),
          keys    : "state",
          type    : "select",
          required: true,
          options : this.stateOption.map((i) => {
            return {
              id: i.id,
              name: this.$I18n(i.name),
            }
          }),
          class   : "md-layout-item",
        },{
          label   : this.$I18n("rev_rem"),
          keys    : "approval_desc",
          type    : "input",
          check   : true,
          required: true,
          class   : "md-layout-item",
        }
      ]
    },
    form_modalData(){
      return [
        {
          label   : this.$I18n("with_acc_id"),
          keys    : "comp_bank_id",
          type    : "select",
          required: true,
          options : this.banks.map(i => ({
            id  : i.id,
            name: i.name,
          })),
          class   : "md-layout-item",
        },{
          label   : this.$I18n("bill"),
          keys    : "invoice_url",
          type    : "file",
          check   : true,
          required: true,
          class   : "md-layout-item",
        },{
          label   : this.$I18n("currency_type"),
          keys    : "currency_code",
          type    : "select",
          required: true,
          check   : true,
          class   : "md-layout-item",
          options : Object.keys(this.balance).map(i => ({
            id  : i,
            name: i,
          })),
          // balance
        },{
          label   : this.$I18n("curr_out_comm"),
          keys    : "extra_curr",
          type    : "input",
          disabled: true,
          check   : true,
          class   : "md-layout-item",
        },{
          label   : this.$I18n("withdrawal_amount"),
          keys    : "amount",
          type    : "input",
          required: true,
          check   : true,
          class   : "md-layout-item",
        },{
          label   : this.$I18n("tax_rate"),
          keys    : "tax_rate",
          type    : "input",
          class   : "md-layout-item",
        }
      ]
    },
  },
  mounted(){
    this.api_getInvo();
    this.api_getBalance();
    this.api_getCompbank();

    this.api_getPageData();
  },
  methods: {  
    // 发票头
    api_getInvo(){
      this.$api.getInvo({})
        .then((res) => {
          this.invo = res.data
        })
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    // 余额
    api_getBalance(){
      this.$api.getBalance({})
        .then((res) => {
          try{
            this.balance = JSON.parse(res.data.rebate_balance)
          }catch(e){
            this.balance = {}
          }
        })
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    // 提现账号
    api_getCompbank(){
      this.$api.getCompbank({
        page_no  : 1,
        page_size: 9999,
      })
        .then((res) => {
          this.banks = res.data.filter((item) => item.state == 1)
        })
        .catch(this.$Catch(this.$I18n("get_error")))
    },
// getWithHis
    // 查询(切换查询data | 查询)
    form_search(){
      this.searchData = {
        state: this.formData.state === "__ALL__" ?0 :this.formData.state,
      }
      this.api_getPageData();
    },
    api_getPageData(){
      this.$api.getWithHis({
        ...this.searchData,
        data_type: 2,
        page_no : this.pageNo,
        page_size:this.pageSize,
      })
        .then((res) => {
          this.tableInitData = res.data;
          this.total = res.count;
        })
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.tableInitData = [];
          this.total = 0;
        }))
    },
    // 增加(打开弹窗 | 添加)
    addModal(){
      this.openModalType = "add";
      this.modalTitle = this.$I18n("add");
      this.modalData.Reset();
      this.modalData.Update({
        ...this.modalData.Form,
        extra_curr: Object.keys(this.balance).length 
          ?Object.keys(this.balance).map(i => `${i}: ${this.balance[i]}`).join(" ; ")
          :"0",
        comp_bank_id: this.banks[0]?.id,
        currency_code: Object.keys(this.balance)[0],
      });
      this.$refs.modal.open();
    },

    // 删除(打开弹窗 | 删除 不能状态是1/3)
    delModal(item){
      this.openModalType = "delete";
      this.modalTitle = this.$I18n("delete");
      this.modalData.Update(item);
      this.$refs.modal.open();
    },

    // 修改(打开弹窗 | 修改(状态 和 审核备注) | 取消: 状态2 -> 5)
    setModal(item){
      this.openModalType = "edit";
      this.modalTitle = this.$I18n("edit");
      this.modalData_edit.Update(item);
      this.$refs.modal.open();
    },
    cancleWithHis(item){
      if(item.state != 2){
        return
      }
      this.$api.setWithHis({
        ...item,
        state: 5,
      })
        .then(() => {
          this.$successMsg(this.$I18n("succ_num"));
          this.api_getPageData();
        })
        .catch(this.$Catch(this.$I18n("fail_num")))
    },
    // 弹窗(提交submit方法 / 切换文件)
    modal_submit(){
      if(this.openModalType != "edit" && this.openModalType != "delete"){
        if(this.modalData.Check()){
          this.$errorMsg(this.$I18n("pls_check_verify"));
          return 
        }
      }
      var promiseObj = {};
      if(this.openModalType == "add"){
        if(!this.modalData.Form.tax_rate){
          this.modalData.Form.tax_rate = "0"
        }
        promiseObj = this.$api.addWithHis({...this.modalData.Form})
      } else if(this.openModalType == "edit") {
        if(!this.modalData_edit.Form.tax_rate){
          this.modalData_edit.Form.tax_rate = "0"
        }
        promiseObj = this.$api.setWithHis({...this.modalData_edit.Form})
      } else {
        promiseObj = this.$api.delWithHis({...this.modalData.Form})
      }
      return promiseObj
        .then(this.$Then(res => {
          if(res.code == 3019){
            this.$errorMsg(this.$I18n("error_code_3019"));
            return 
          }
          this.$successMsg(this.$I18n("succ_num"));
          this.$refs.modal.close();
          this.api_getPageData();
        }, [3019]))
        .catch(this.$Catch(this.$I18n("fail_num")))
    },
    changeFile(value, name){
      this.modalData.Form.invoice_url = value;
      this.modalData.Form.invoice_url_name = name;
    },
    async openPDF(url){
      console.log(url)
      try {
        const response = await fetch(url);
        const blob = await response.blob();
        // 强制指定类型为 PDF
        const pdfBlob = new Blob([blob], { type: 'application/pdf' });
        const blobUrl = URL.createObjectURL(pdfBlob);
        
        window.open(blobUrl, '_blank');
        
        // 可选：一段时间后释放内存
        setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
      } catch (err) {
        console.error('打开失败', err);
        alert('无法预览，请检查跨域或权限');
      }
    },
  },
};
</script>
<style lang="css" scoped>
  .md-modal-diy /deep/ .md-icon{
    margin-left:  auto !important;
    margin-right: 0!important;
  }
  .imagebox{
    width: 100%;
    padding:17px 0 23px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    min-height: 123.500px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .click-upload{
    color: #888888;
  }
  .modal-loader /deep/ .uploader-drop{
    width: 592px !important;
    /*line-height: 240px;*/
  }
  .md-table-md-button /deep/ .md-ripple{
    padding: 0 !important;
  }
  .md-table-md-button {
    padding: 0 20px !important;
    /*margin-right: 5px;*/
  }
  .md-table-md-button.md-disabled {
    cursor: not-allowed !important;
  }
  .search-icon{
    position: absolute;
    right: 5px; 
    top: 5px;
    border: 1px dashed #BBBBBB; 
    border-radius: 5px;
    padding: 5px; 
    cursor: pointer;
    z-index: 10;
    display: inline-block;
  }
  .other-modal /deep/ .modal-mask{
    z-index: 1000;
  }
</style>
<style lang="scss" scoped>
  .left-layout{
    padding-left: 0;
  }
  .right-layout{
    padding-right: 0;
  }
  .md-card-only-title{
    margin: 0;
    box-shadow: none;
    text-align: left;
    position: relative;
    top: -12px;
    left: -20px;
  }
  .md-card-only-title .title{
    text-align:left !important;
  }
  .total-page{
    width: 30%;
    display: inline-block;
  }
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  .button-box.small {
    width: 80px;
  }
  //左侧iocn
  .left-icon{
    margin-right: 16px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
</style>